import {Component, OnInit} from '@angular/core';
import {MusicCollectionService} from '../../service/MusicCollectionService';
import {ArtistsCollection} from '../../model/ArtistsCollection';
import {ArtistSummary} from '../../model/ArtistSummary';
import {Subject} from 'rxjs';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {MusicCollectionSettingsService} from '../../service/MusicCollectionSettingsService';

@Component({
  selector: 'app-artist-collection',
  templateUrl: './artist-collection.component.html',
  styleUrls: ['./artist-collection.component.scss']
})
export class ArtistCollectionComponent implements OnInit {

  artistsCollection: ArtistsCollection;
  artistSortView: string = MusicCollectionSettingsService.ARTIST_SORT_ALPHABETICAL;
  sortedArtists: Array<ArtistSummary>;
  searchText: string;
  searchModelChanged: Subject<string> = new Subject<string>();
  searchTextForFiltering: string;

  constructor(private musicCollectionService: MusicCollectionService,
              private musicCollectionSettingsService: MusicCollectionSettingsService) {
  }

  ngOnInit(): void {
    console.log('in ArtistCollectionComponent.ngOnInit()');
    this.initializeArtistSortView();
    this.configureSearchListener();
    this.getArtistSummaryCollection();
  }

  getArtistSummaryCollection(): void {
    this.musicCollectionService.getArtistSummaryCollection().subscribe(result => this.processCollection(result));
  }

  processCollection(artists: Array<ArtistSummary>): void {
    console.log('Processing artist collection');
    this.artistsCollection = new ArtistsCollection();
    this.artistsCollection.deserializeArtists(artists);
    this.setSortedArtistsBasedOnSortView();
  }

  initializeArtistSortView(): void {
    this.artistSortView = this.musicCollectionSettingsService.getArtistSortViewFromLocalStorage(
      MusicCollectionSettingsService.ARTIST_SORT_ALPHABETICAL);
  }

  configureSearchListener(): void {
    this.searchModelChanged
      .pipe(
        debounceTime(500),
        distinctUntilChanged())
      .subscribe(model => {
        this.searchTextForFiltering = model;
      });
  }

  searchTextChanged(text: string): void {
    this.searchModelChanged.next(text);
  }

  artistSortViewIsAlphabetical(): boolean {
    return this.artistSortView === MusicCollectionSettingsService.ARTIST_SORT_ALPHABETICAL;
  }

  artistSortViewIsAlbumCount(): boolean {
    return this.artistSortView === MusicCollectionSettingsService.ARTIST_SORT_ALBUM_COUNT;
  }

  sortAlphabetical(): void {
    this.clearSearchText();
    this.artistSortView = MusicCollectionSettingsService.ARTIST_SORT_ALPHABETICAL;
    this.sortedArtists = this.artistsCollection.getArtistsSortedAlphabetically();
    this.musicCollectionSettingsService.storeArtistSortViewInLocalStorage(this.artistSortView);
  }

  sortByMostAlbums(): void {
    this.clearSearchText();
    this.artistSortView = MusicCollectionSettingsService.ARTIST_SORT_ALBUM_COUNT;
    this.sortedArtists = this.artistsCollection.getArtistsSortedByMostAlbums();
    this.musicCollectionSettingsService.storeArtistSortViewInLocalStorage(this.artistSortView);
  }

  setSortedArtistsBasedOnSortView(): void {
    switch (this.artistSortView) {
      case MusicCollectionSettingsService.ARTIST_SORT_ALPHABETICAL:
        this.sortedArtists = this.artistsCollection.getArtistsSortedAlphabetically();
        break;
      case MusicCollectionSettingsService.ARTIST_SORT_ALBUM_COUNT:
        this.sortedArtists = this.artistsCollection.getArtistsSortedByMostAlbums();
        break;
      default:
        console.log('Unexpected artist sort view of ' + this.artistSortView);
        this.sortedArtists = this.artistsCollection.getArtistsSortedAlphabetically();
    }
  }

  clearSearchText(): void {
    this.searchText = '';
    this.searchTextForFiltering = '';
  }



}
